import { render, staticRenderFns } from "./Carga.vue?vue&type=template&id=5b219850&"
import script from "./Carga.vue?vue&type=script&lang=js&"
export * from "./Carga.vue?vue&type=script&lang=js&"
import style0 from "./Carga.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports